import React from "react";
import cn from "clsx";
import includes from "lodash/includes";
import { useTranslation } from "react-i18next";
import { emailValidationRegExp } from "../../constants";
import "./style.scss";

const GuestTrackingOrder = ({
  handleTextChange,
  handleOnClickTrackOrder,
  orderId,
  email,
  trackOrderGuest,
  showContent,
  trackOrderR
}) => {
  const { t } = useTranslation("trackOrder");
  const buttonIsDisabled = !orderId || !emailValidationRegExp.test(email);
  return (
    <div
      className={cn("guest_track_wrapper", {
        guest_order_page: trackOrderGuest
      })}
    >
      <h3>{trackOrderGuest ? t("trackAnotherOrder") : t("guestTrackText")}</h3>
      <div className="form-group">
        <input
          type="text"
          className="form-control"
          name="orderId"
          value={orderId}
          onChange={handleTextChange}
          placeholder={t("orderNumber")}
          aria-label="Order id"
        />
      </div>
      <div className="form-group">
        <input
          type="email"
          className="form-control"
          name="email"
          placeholder={t("emailAddress")}
          value={email}
          onChange={handleTextChange}
          aria-label="Email"
        />
      </div>
      <button
        className={cn("round_btn form_black_btn width_auto", {
          disabled: buttonIsDisabled
        })}
        onClick={handleOnClickTrackOrder}
        disabled={buttonIsDisabled}
      >
        {t("trackOrder")}
      </button>
      {!includes(trackOrderR.orderId, orderId) && showContent && (
        <div className="container noRecordFound">{trackOrderR.message}</div>
      )}
      {!includes(trackOrderGuest, orderId) && <p>{t("eyeOnOrder")}</p>}
    </div>
  );
};

export default GuestTrackingOrder;
